import { ChangePasswordView } from "@components";

export const ChangePassword = () => {
    return (
        <>
            <ChangePasswordView />
        </>
    );
};
